export default __webpack_public_path__ + "static/media/12.112d8558.svg";